import React from "react";
import './App.css';

const LoadingScreen = () => {
  return (
    <div className="fullscreen-container">
      <h1>Loading...</h1>
    </div>
  );
};

export default LoadingScreen;